export enum CategoryType {
  READY_TO_WEAR = "READY TO WEAR",
  UNSTITCHED = "UNSTITCHED",
  FORMAL_WEAR = "FORMAL WEAR",
}
